import React, {Component} from 'react';
import Page from '../../page/page'
// import ScrollBox from '../scroll/scroll';//生产
import ScrollBox from '../../scroll/scrollBox2.0';
import Svg from '../../svg/index'
import Button from '../../button/button'
import {styleObj} from './styles';

Array.prototype.S = String.fromCharCode(2);
Array.prototype.in_array = function (e) {
    let r = new RegExp(this.S + e + this.S);
    return (r.test(this.S + this.join(this.S) + this.S));
};
let clickCount = 0;

class TableField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            styles: styleObj,
            tableData: [],
            tableObj: [],
            // shouldUpdate: true,
            bgColor: '',
            textColor: '',
            _bgColor: '',
            _textColor: '',
            as: false,//是否点击升序
            de: false,//是否点击降序

            itemArr: [],
            itemData: [],
            selectAll: false,

        };
    }

    componentWillReceiveProps(nextProps) {
        if (JSON.stringify(nextProps.tableData) !== (JSON.stringify(this.props.tableData))) {
            const itemArr = [];
            const itemData = [];
            const tableData = nextProps.tableData;
            tableData.forEach((item) => {
                if (item.defaultChecked === true) {
                    itemArr.push(item.tableId)
                    itemData.push(item)
                }
            })
            this.setState({
                tableData: nextProps.tableData,
                itemArr,
                itemData,
            })
            if (nextProps.checkType === "radio") {
                nextProps.handleItem && nextProps.handleItem({}, "radio")
            } else {
                nextProps.handleItem && nextProps.handleItem([], "checkbox")
            }
        }
        if (JSON.stringify(nextProps.tableObj) !== (JSON.stringify(this.props.tableObj))) {
            this.setState({
                tableObj: nextProps.tableObj,
            })
        }
    }

    componentDidMount() {

        for (let i of this.props.tableObj) {
            i.show = false
        }
        const itemArr = [];
        const itemData = [];
        const tableData = this.props.tableData;
        tableData.forEach((item) => {
            if (item.defaultChecked === true) {
                itemArr.push(item.tableId)
                itemData.push(item)
            }
        })
        this.setState({
            tableData: tableData,
            tableObj: this.props.tableObj,
            itemArr,
            itemData,
        })
    }

    // initScroll = () => {
    //     this.setState({ shouldUpdate: false });
    // };
    mouseOver = (index, data) => {

        data[index].show = true;
        this.setState({
            tableObj: data
        })
    };
    mouseOut = (index, data) => {

        data[index].show = false;
        this.setState({
            tableObj: data
        })
    };
    overColor = () => {
        this.setState({
            bgColor: "#ccc",
            textColor: "white",
        })
    };
    outColor = () => {
        this.setState({
            bgColor: "#f9f9f9",
            textColor: "#888",

        })
    };
    _overColor = () => {
        this.setState({
            _bgColor: "#ccc",
            _textColor: "white"
        })
    };
    _outColor = () => {
        this.setState({
            _bgColor: "#f9f9f9",
            _textColor: "#888",
        })
    };

    handleClick = (value) => {
        clickCount++;
        setTimeout(() => {
            if (clickCount == 1) {
                this.setSelectItem(value)
            } else if (this.props.checkType == "radio" && clickCount == 2) {
                this.setState({
                    itemArr: [value.tableId],
                    itemData: [value]
                });
                this.props.handleDoubleClick && this.props.handleDoubleClick(value);
            }
            clickCount = 0
        }, 200)
    };
    setSelectItem = (value) => {
        debugger
        if (this.props.checkType == "radio") {
            this.setState({
                itemArr: [value.tableId],
                itemData: [value]
            });
            this.props.handleItem && this.props.handleItem(value, "radio")
        } else {
            let itemArr = this.state.itemArr;
            let itemData = this.state.itemData;
            let num = itemArr.indexOf(value.tableId);
            if (num > -1) {
                itemArr.splice(num, 1);
                itemData.splice(num, 1);
            } else {
                itemArr.push(value.tableId);
                itemData.push(value);
            }
            this.setState({
                itemArr,
                itemData
            });
            this.props.handleItem && this.props.handleItem(itemData, "checkbox")
        }
    };
    setSelectItemAll = () => {
        let selectAll = this.state.selectAll;
        let itemArr = [];
        let itemData = [];
        let tableData = this.state.tableData;
        if (!selectAll) {
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].isChoose) {
                    itemArr.push(tableData[i].tableId);
                    itemData.push(tableData[i])
                }
            }
        }
        this.setState({
            selectAll: !selectAll,
            itemArr,
            itemData
        });
        this.props.handleItem && this.props.handleItem(itemData, this.props.checkType == "radio" ? "radio" : "checkbox", "all")
    };
    handleSequence = (type, property, data, index, array) => {

        var sortObj = data.sort((prev, next) => {

            let a = prev[property];
            let b = next[property];
            for (let i of array) {
                i.as = false;
                i.de = false;
            }
            //升序 ascending

            if (type == "ascending") {

                array[index].as = true;
                array[index].de = false;
                this.setState({
                    tableObj: array
                });
                return a.toString().localeCompare(b)
            }

            //降序descending
            if (type == "descending") {
                array[index].as = false;
                array[index].de = true;
                this.setState({
                    tableObj: array
                });
                return b.toString().localeCompare(a)
            }

            // return function (obj1, obj2) {
            //     let a = obj1[property];
            //     let b = obj2[property];
            //     return type == "ascending" ? a.toString().localeCompare(b) :
            //         type == "descending" ? b.toString().localeCompare(a) : 0
            // }
        });
        this.setState({
            tableData: sortObj
        });

        array[index].show = false;
        this.setState({
            tableObj: data
        })

    };
    handleScroll = (e) => {

        document.getElementById('table').scrollTop = e.currentTarget.scrollTop;

    };
    handleBtn = (item) => {
        let itemData = this.state.itemData;
        let tableData = this.state.tableData;
        itemData = itemData.filter((item, index) => {
            return tableData.some((tItem, index) => item.tableId == tItem.tableId)
        });
        this.props.handleBtn(itemData, item.type)
    };

    render() {
        const {...props} = this.props, {...state} = this.state;
        let styles = state.styles, tabWidth = 0, lockTabWidth = this.props.checkBox ? 5 : 2,
            tabBoxWidth = parseInt(props.width);
        for (let i = 0; i < state.tableObj.length; i++) {
            if (state.tableObj[i].isLock) {
                lockTabWidth += parseInt(state.tableObj[i].fieldWidth)
            } else {
                tabWidth += parseInt(state.tableObj[i].fieldWidth)
            }
        }
        let minHeight = props.minHeight ? parseInt(props.minHeight) + 2.5 : 2.5;
        tabBoxWidth = tabBoxWidth - lockTabWidth;

        return (
            <div style={Object.assign({}, styles.table, {width: props.width})}>
                <div style={styles.mdAction}>
                    {props.actions.map((item, index) => (
                        <div style={Object.assign({}, styles.spanBtn, {background: item.color || "#059a05"})}
                             key={index + '-btn'} onClick={this.handleBtn.bind(this, item)}>
                            {item.name}
                            {/*<Button scenesType="submit" btnText={item.name}*/}
                            {/*handleBtn={this.props.handleBtn.bind(this, itemData, item.type)}/>*/}
                        </div>
                    ))
                    }
                </div>
                <div style={{position: "relative"}}>
                    <div style={{minHeight: minHeight + 'rem'}}>
                        <table style={Object.assign({}, styles.tb1, {
                            width: lockTabWidth + "rem",
                            position: "relative",
                        })}>
                            <thead style={styles.thead}>
                            <tr style={Object.assign({}, styles.lockTheadTr)}>
                                {this.props.checkBox && this.props.checkType != "radio" ?
                                    <td onClick={this.setSelectItemAll} style={styles.checkBox}>
                                        {this.state.selectAll ?
                                            <Svg type={this.props.checkType == 'radio' ? "RadioOn" : "CheckboxOn"}
                                                 width="1rem" height="1rem" fill="#4aa5fe"/> :
                                            <Svg type={this.props.checkType == 'radio' ? "RadioOff" : "CheckboxOff"}
                                                 width="1rem" height="1rem" fill="#ccc"/>
                                        }
                                    </td> : null
                                }
                                {props.tableObj.map((value, index, array) => (
                                        value.isLock ?
                                            <td onMouseOver={value.isSequence ? this.mouseOver.bind(this, index, array) : null}
                                                onMouseOut={value.isSequence ? this.mouseOut.bind(this, index, array) : null}
                                                style={{
                                                    cursor: value.isSequence ? "pointer" : null,
                                                    width: value.fieldWidth
                                                }} key={index}>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}>
                                                    {value.fieldText}
                                                    {value.isSequence ?
                                                        <div style={styles.sequenceSvg}>
                                                            <Svg type="Up" width="1rem" height="1rem"
                                                                 fill={value.as ? "#4aa5ff" : "#ccc"}/>
                                                            <Svg type="Down" width="1rem" height="1rem"
                                                                 fill={value.de ? "#4aa5ff" : "#ccc"}/>
                                                        </div> :
                                                        null
                                                    }

                                                </div>

                                                {/* {value.isSequence ? (value.as ? " ↑" : value.de ? " ↓" : " ↑↓"): null} */}
                                                {<div style={{
                                                    cursor: "pointer",
                                                    width: value.fieldWidth,
                                                    position: "absolute",
                                                    display: value.show ? "block" : "none",
                                                    background: "#f9f9f9",
                                                    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)"
                                                }}>
                                                    <div onMouseOver={this.overColor}
                                                         onMouseOut={this.outColor}
                                                         style={Object.assign({}, styles.sequenceItem, {
                                                             background: state.bgColor,
                                                             color: state.textColor
                                                         })}
                                                         onClick={this.handleSequence.bind(this, "ascending", value.fieldName, state.tableData, index, array)}>
                                                        升序 &nbsp; <Svg type="Up" width="1rem" height="1rem" fill="#4aa5ff"/>
                                                    </div>
                                                    <div onMouseOver={this._overColor}
                                                         onMouseOut={this._outColor}
                                                         style={Object.assign({}, styles.sequenceItem, {
                                                             background: state._bgColor,
                                                             color: state._textColor
                                                         })}
                                                         onClick={this.handleSequence.bind(this, "descending", value.fieldName, state.tableData, index, array)}>
                                                        降序 &nbsp; <Svg type="Down" width="1rem" height="1rem"
                                                                       fill="#4aa5ff"/>
                                                    </div>
                                                </div>
                                                }
                                            </td> : null
                                    )
                                )}
                            </tr>
                            </thead>
                        </table>


                        <ScrollBox autohide={false}
                                   style={styles.tableBox}
                                   maxHeight={props.maxHeight ? props.maxHeight : '30rem'}
                                   updateScrollBar={props.updateScrollBar}
                        >
                            {/*tableBox:
                             tb1  | tab2
                             ———————————
                             tb3  | tab4
                             */}
                            <table style={Object.assign({}, styles.tb2, {
                                width: tabBoxWidth + "rem",
                                position: 'sticky',
                                zIndex: 8,
                                top: "0rem",
                                marginLeft: lockTabWidth + "rem",
                            })}>
                                <thead style={styles.thead}>

                                <tr style={Object.assign({}, styles.theadTr)}>
                                    {props.tableObj.map((value, index, array) => (
                                        !value.isLock ?
                                            <td onMouseOver={value.isSequence ? this.mouseOver.bind(this, index, array) : null}
                                                onMouseOut={value.isSequence ? this.mouseOut.bind(this, index, array) : null}
                                                style={{
                                                    cursor: value.isSequence ? "pointer" : null,
                                                    width: value.fieldWidth,
                                                    position: "relative"
                                                }} key={index}>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center"
                                                }}>
                                                    {value.fieldText}
                                                    {value.isSequence ?
                                                        <div style={styles.sequenceSvg}>
                                                            <Svg type="Up" width="1rem" height="1rem"
                                                                 fill={value.as ? "#4aa5ff" : "#ccc"}/>
                                                            <Svg type="Down" width="1rem" height="1rem"
                                                                 fill={value.de ? "#4aa5ff" : "#ccc"}/>
                                                        </div> :
                                                        null
                                                    }

                                                </div>
                                                {<div style={{
                                                    cursor: "pointer",
                                                    width: value.fieldWidth,
                                                    position: "absolute",
                                                    display: value.show ? "block" : "none",
                                                    background: "#f9f9f9",
                                                    boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)"
                                                }}>
                                                    <div
                                                        onMouseOver={this.overColor}
                                                        onMouseOut={this.outColor}
                                                        style={Object.assign({}, styles.sequenceItem, {
                                                            background: state.bgColor,
                                                            color: state.textColor
                                                        })}
                                                        onClick={this.handleSequence.bind(this, "ascending", value.fieldName, state.tableData, index, array)}>
                                                        升序 &nbsp; <Svg type="Up" width="1rem" height="1rem"
                                                                       fill="#4aa5ff"/>
                                                    </div>
                                                    <div
                                                        onMouseOver={this._overColor}
                                                        onMouseOut={this._outColor}
                                                        style={Object.assign({}, styles.sequenceItem, {
                                                            background: state._bgColor,
                                                            color: state._textColor
                                                        })}
                                                        onClick={this.handleSequence.bind(this, "descending", value.fieldName, state.tableData, index, array)}>
                                                        降序 &nbsp; <Svg type="Down" width="1rem" height="1rem"
                                                                       fill="#4aa5ff"/>
                                                    </div>
                                                </div>
                                                }

                                            </td> : null
                                    ))}
                                </tr>
                                </thead>
                            </table>
                            {state.tableData.length ? [
                                <table key="1" style={Object.assign({}, styles.tb3, {
                                    width: lockTabWidth + "rem",
                                })}>
                                    <tbody style={styles.locktbody}>
                                    {state.tableData.map((value, index) => (
                                        <tr key={index}
                                            onClick={this.handleClick.bind(this, value)}
                                            style={Object.assign({},
                                                this.props.rowBgColor == "none" ? styles[`tbodyTr${2}`] : styles[`tbodyTr${index % 2}`],
                                                {height: props.lineHeight || "2.5rem"})}
                                        >
                                            {props.checkBox ?
                                                value.isChoose ?
                                                    <td style={styles.checkBox}>
                                                        {this.state.itemArr.includes(value.tableId) ?
                                                            <Svg
                                                                type={this.props.checkType == 'radio' ? "RadioOn" : "CheckboxOn"}
                                                                width="1rem" height="1rem"
                                                                fill="#4aa5fe"/> :
                                                            <Svg
                                                                type={this.props.checkType == 'radio' ? "RadioOff" : "CheckboxOff"}
                                                                width="1rem" height="1rem"
                                                                fill="#ccc"/>
                                                        }
                                                    </td> : <td style={styles.checkBox}></td>
                                                : null
                                            }

                                            {props.tableObj.map((objname, index) => (
                                                objname.isLock ?
                                                    <td title={typeof value[objname.fieldName] == "object" ? "" : value[objname.fieldName]}
                                                        style={{
                                                            width: objname.fieldWidth,
                                                            textOverflow: "ellipsis",
                                                            overflow: "hidden",
                                                            whiteSpace: "nowrap",
                                                            display: "block"
                                                        }}
                                                        key={index + 'gfy'}>{value[objname.fieldName]}</td> : null
                                            ))
                                            }
                                        </tr>
                                    ))}
                                    {/*<tr key="last"*/}
                                    {/*style={Object.assign({}, styles[`tbodyTr0`], {height: props.lineHeight || "2.5rem"})}>*/}
                                    {/*</tr>*/}

                                    </tbody>
                                </table>,
                                <table key="2" style={Object.assign({}, styles.tb4, {
                                    width: tabBoxWidth + "rem",
                                    left: lockTabWidth + "rem",
                                })}>
                                    <tbody style={styles.tbody}>
                                    {state.tableData.length ?
                                        state.tableData.map((value, index) => (
                                            <tr key={index}
                                                style={Object.assign({},
                                                    this.props.rowBgColor == "none" ? styles[`tbodyTr${2}`] : styles[`tbodyTr${index % 2}`],
                                                    {height: props.lineHeight || "2.5rem"})}

                                                onClick={this.handleClick.bind(this, value)}
                                            >
                                                {props.tableObj.map((objname, index) => {
                                                    {
                                                        this.props.checkBox && value.isChoose && !objname.isLock ?
                                                            <td
                                                                style={styles.checkBox}>
                                                                {this.state.itemArr.includes(value.tableId) ?
                                                                    <Svg
                                                                        type={this.props.checkType == 'radio' ? "RadioOn" : "CheckboxOn"}
                                                                        width="1rem" height="1rem"
                                                                        fill="#4aa5fe"/> :
                                                                    <Svg
                                                                        type={this.props.checkType == 'radio' ? "RadioOff" : "CheckboxOff"}
                                                                        width="1rem" height="1rem"
                                                                        fill="#4aa5fe"/>
                                                                }
                                                            </td> : null
                                                    }
                                                    let dom = [];
                                                    if (index == props.tableObj.length - 1 && objname.fieldName == "operating") {
                                                        dom.push(<td
                                                            title={typeof value[objname.fieldName] == "object" ? "" : value[objname.fieldName]}
                                                            key={index + 'gfy'}
                                                            style={{
                                                                width: objname.fieldWidth,
                                                                textOverflow: "ellipsis",
                                                                overflow: "hidden",
                                                                whiteSpace: "nowrap",
                                                                display: "block",
                                                                boxSizing: "border-box",
                                                                padding: "0 0.4rem",
                                                            }}
                                                            onClick={props.operatingFn ? props.operatingFn.bind(this, value) : () => null}
                                                        >
                                                            <div>查看</div>
                                                        </td>);
                                                    } else {
                                                        dom.push(!objname.isLock ?
                                                            <td title={typeof value[objname.fieldName] == "object" ? "" : value[objname.fieldName]}
                                                                key={index + 'gfy'}
                                                                style={{
                                                                    width: objname.fieldWidth,
                                                                    textOverflow: "ellipsis",
                                                                    overflow: "hidden",
                                                                    whiteSpace: "nowrap",
                                                                    display: "block",
                                                                    boxSizing: "border-box",
                                                                    padding: "0 0.4rem",
                                                                }}>
                                                                {value[objname.fieldName]}
                                                            </td> : null);
                                                    }
                                                    return dom;
                                                })}
                                            </tr>)) :
                                        <tr style={styles.emptyBox}>
                                            <td style={styles.loadBox}>
                                                {this.props.loading ?
                                                    <div style={styles.loading}>
                                                        正在拼命加载数据中
                                                        {/*<Loading tip={true} tipText={"正在拼命加载数据中..."} />*/}
                                                    </div> :
                                                    <label style={styles.emptyText}>没有找到匹配的数据</label>
                                                }
                                            </td>
                                        </tr>
                                    }
                                    {/*<tr key="last"*/}
                                    {/*style={Object.assign({}, styles[`tbodyTr0`], {height: props.lineHeight || "2.5rem"})}>*/}
                                    {/*</tr>*/}
                                    </tbody>
                                </table>
                            ] : [<div style={{height: "4rem"}}></div>]}
                        </ScrollBox>
                    </div>

                    {!state.tableData.length ? <div style={{
                        position: "absolute",
                        top: "4em",
                        zIndex: "1",
                        width: "100%",
                        textAlign: "center"
                    }}>空空如也</div> : null}

                    {props.hidePage ? null :
                        <div style={Object.assign({}, styles.pageBox, {width: props.width})}>
                            <Page handlePage={props.handlePage}
                                  totalNum={props.totalNum}
                                  pageNumber={props.pageNumber}
                                  pageSize={props.pageSize || 10}
                                  showPageSize={true}
                                  selectData={props.selectData}
                                  selectId={props.selectId}
                            />
                        </div>

                    }

                </div>

            </div>
        )
    }
}

export default TableField;
